import {useLocation} from "react-router-dom";
import {useSession} from "./SessionProvider";
import {useShopSite} from "./ShopSiteProvider";
import {shouldShowShopChrome} from "@/lib/authShell";
import {ShopHeader} from "./ShopHeader";
import {ShopFooter} from "./ShopFooter";
import {MobileMenu} from "./MobileMenu";
import {CartDrawer} from "./CartDrawer";
import {BackTop} from "./BackTop";

export function ShopChrome({children}: {children: React.ReactNode}) {
  const {pathname} = useLocation();
  const {user, ready} = useSession();
  const {status, ready: siteReady} = useShopSite();
  const showChrome = shouldShowShopChrome(pathname, user, ready, siteReady, status.publicAccess);
  return (
    <>
      {showChrome ? <ShopHeader /> : null}
      {children}
      {showChrome ? <ShopFooter /> : null}
      {showChrome ? <MobileMenu /> : null}
      {showChrome ? <CartDrawer /> : null}
      {showChrome ? <BackTop /> : null}
    </>
  );
}
